import * as React from "react";
import { toast } from "@grandvisionhq/common";
import { useMutation } from "@grandvisionhq/graphql";
import { useIntl } from "@grandvisionhq/state";
import { useDispatchTrackErrorEvent } from "@grandvisionhq/svc-tealium/events";
import { CREATE_APPLE_PAY_SESSION } from "../../../../operations/mutations/operations/mutations/create-apple-pay-session.js";
const useCreateApplePaySession = () => {
  const dispatchTrackErrorEvent = useDispatchTrackErrorEvent();
  const { getLabel } = useIntl();
  const [mutationCallback, mutation] = useMutation(CREATE_APPLE_PAY_SESSION);
  const Error_Label = getLabel("checkout.express.apple.pay.errors.failed");
  const domainName = typeof window !== "undefined" && window?.location?.hostname;
  const createApplePaySession = React.useCallback(
    async (session) => {
      return await mutationCallback({
        variables: {
          applePaySessionInput: {
            domainName
          }
        }
      }).then((response) => {
        const merchantSessionData = response?.data?.createApplePaySession?.data;
        if (session && merchantSessionData) {
          const decodedMerchantSession = atob(merchantSessionData);
          const decodedAndParsedMerchantSession = JSON.parse(decodedMerchantSession);
          try {
            session.completeMerchantValidation(decodedAndParsedMerchantSession);
          } catch (e) {
            if (!(e instanceof Error && e.name === "InvalidAccessError")) {
              console.error(e);
              toast.failed("checkout.express.apple.pay.errors.failed");
              dispatchTrackErrorEvent(
                () => Promise.resolve({
                  Error_Source: "Server",
                  Error_Code: "Create apple pay session error",
                  Error_Details: Error_Label,
                  Error_Message: e instanceof Error ? e.message : ""
                })
              );
              session.abort();
            }
          }
        }
      }).catch((error) => {
        console.error("useCreateApplePaySession: createApplePaySession error", error);
        toast.failed("checkout.express.apple.pay.errors.failed");
        dispatchTrackErrorEvent(
          () => Promise.resolve({
            Error_Source: "Server",
            Error_Code: "Create apple pay session error",
            Error_Details: Error_Label,
            Error_Message: error instanceof Error ? error.message : ""
          })
        );
        session.abort();
      });
    },
    [Error_Label, dispatchTrackErrorEvent, domainName, mutationCallback]
  );
  return { createApplePaySession, isLoading: mutation.loading, updateError: mutation.error };
};
export {
  useCreateApplePaySession
};
//# sourceMappingURL=use-create-apple-pay-session.js.map
